import React from 'react';
import { Modal, Input, Button } from 'semantic-ui-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  setTemplateGenerationWeight,
  setTemplateGenerationCalories,
  changeTemplateName,
} from '../../actions/templateGenerator';

const TemplateGenerationValuesModal = ({
  isOpen,
  onClose,
  onSubmit,
  templateGenerationWeight,
  templateGenerationCalories,
  setTemplateGenerationWeight,
  setTemplateGenerationCalories,
  templateName,
  changeTemplateName,
}) => {
  const [isErrorTemplateName, setIsErrorTemlateName] = React.useState(false);
  const [isErrorWeight, setIsErrorWeight] = React.useState(false);
  const [isErrorCalories, setIsErrorCalories] = React.useState(false);

  const validation = React.useCallback((value) => {
    return value.trim() === '' || (+value >= 0 && +value <= 100000);
  });

  const onChangeWeight = React.useCallback(
    (e) => {
      const valueStr = e.target.value;
      if (validation(valueStr)) setTemplateGenerationWeight(+valueStr);
      if (isErrorWeight) setIsErrorWeight(false);
    },
    [templateGenerationWeight],
  );

  const onChangeCalories = React.useCallback(
    (e) => {
      const valueStr = e.target.value;
      if (validation(valueStr)) setTemplateGenerationCalories(+valueStr);
      if (isErrorCalories) setIsErrorCalories(false);
    },
    [templateGenerationCalories],
  );

  const onSubmitTemplateGenerationValues = React.useCallback(() => {
    const isWeightError = templateGenerationWeight <= 0;
    const isCaloriesError = templateGenerationCalories <= 0;
    const isTemplateNameError = templateName.trim() === '';
    setIsErrorTemlateName(isTemplateNameError);
    setIsErrorWeight(isWeightError);
    setIsErrorCalories(isCaloriesError);
    if (isWeightError || isCaloriesError || isTemplateNameError) return;
    onSubmit();
    onClose();
  }, [templateGenerationWeight, templateGenerationCalories, templateName]);

  const onChangeTemplateName = React.useCallback(
    (e) => {
      if (isErrorTemplateName) setIsErrorTemlateName(false);
      changeTemplateName(e.target.value);
    },
    [templateName],
  );

  return (
    <Modal open={isOpen} onClose={onClose} closeIcon size="tiny">
      <Modal.Header>Значения генерации</Modal.Header>
      <WrapFormElem>
        <LabelInput>Имя шаблона</LabelInput>
        <Input
          fluid
          placeholder="Имя шаблона"
          value={templateName}
          onChange={onChangeTemplateName}
          error={isErrorTemplateName}
        />
      </WrapFormElem>
      <WrapFormElem>
        <LabelInput>Вес клиента, на который расчитывется меню</LabelInput>
        <Input
          fluid
          placeholder="Значение веса"
          value={templateGenerationWeight}
          onChange={onChangeWeight}
          error={isErrorWeight}
        />
      </WrapFormElem>
      <WrapFormElem>
        <LabelInput>Калорийность на которую расчитывется меню</LabelInput>
        <Input
          fluid
          placeholder="Количество калорий"
          value={templateGenerationCalories}
          onChange={onChangeCalories}
          error={isErrorCalories}
        />
      </WrapFormElem>
      <WrapFormElem>
        <Button fluid color="blue" onClick={onSubmitTemplateGenerationValues}>
          Сгенерировать шаблон
        </Button>
      </WrapFormElem>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  templateGenerationWeight: state.templateGenerator.templateGenerationWeight,
  templateGenerationCalories: state.templateGenerator.templateGenerationCalories,
  templateName: state.templateGenerator.templateName,
});

const mapDispatchToProps = (dispatch) => ({
  changeTemplateName: (name) => dispatch(changeTemplateName(name)),
  setTemplateGenerationWeight: (weight) => dispatch(setTemplateGenerationWeight(weight)),
  setTemplateGenerationCalories: (calories) => dispatch(setTemplateGenerationCalories(calories)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateGenerationValuesModal);

const LabelInput = styled.div`
  font-size: 14px;
  margin: 15px 0px;
  font-weight: bold;
`;

const WrapFormElem = styled.div`
  margin: 20px;
`;



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/TemplateGenerationValuesModal.jsx